#import "@/apollo/fragments/Comment.gql"

mutation AddQAAnnotationCommentOnComputedDeliverable($annotationId: ID!, $content: String!, $mentions: [String]) {
    addQAAnnotationCommentOnComputedDeliverable(annotationId: $annotationId, content: $content, mentions: $mentions) {
        ...Comment
    }
}
